var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm6.947 12.905c0 .605-.49 1.095-1.095 1.095l-1.56-.205c-.605 0-1.095-.49-1.095-1.095l-.148-1.578c-1.939-.868-3.968-.91-6.099 0L8.802 12.7c0 .605-.49 1.095-1.095 1.095L6.147 14c-.605 0-1.095-.49-1.095-1.095l-.053-1.038c0-.747.314-1.416.804-1.906 2.711-2.711 9.874-2.517 12.391 0 .49.49.805 1.159.804 1.906l-.053 1.038z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.59a9b32f6e6733d6ac30591234bf0685.svg";
export { ForwardRef as ReactComponent };